import { ELSSlideSwitch } from '@els/els-component-form-field-react';
import cx from 'classnames';
import { onKeyDownHandler } from 'helpers/ui.helper';
import { ConditionSection, ELSButton, FalseStatement, TrueStatement } from '..';
var TOGGLE_ID = 'expand-all-button__toggle';
var ExpandAllButton = function (_a) {
    var isExpandAll = _a.isExpandAll, handleExpandAll = _a.handleExpandAll, customRenderExpandAllButton = _a.customRenderExpandAllButton, _b = _a.hideCondition, hideCondition = _b === void 0 ? false : _b, _c = _a.isSlideSwitch, isSlideSwitch = _c === void 0 ? false : _c;
    if (hideCondition) {
        return null;
    }
    var label = isExpandAll ? 'Collapse All' : 'Expand All';
    return (<div className={cx('c-expand-all-button__wrapper', { 'c-expand-all-button__wrapper--slide-switch': isSlideSwitch })}>
      <ConditionSection condition={isSlideSwitch}>
        <TrueStatement>
          {typeof customRenderExpandAllButton === 'function' && customRenderExpandAllButton()}
          <div className={cx('c-expand-all-button__button', { 'c-expand-all-button__button-expanded': !isExpandAll })}>
            <ELSSlideSwitch id={TOGGLE_ID} name={TOGGLE_ID} size="small" checked={isExpandAll} label={label} changeHandler={handleExpandAll} labelStateIsOn="Expand All" labelStateIsOff="Collapse All"/>
          </div>
        </TrueStatement>
        <FalseStatement>
          <ELSButton size="xsmall" className="c-expand-all-button__button" onClick={handleExpandAll} onKeyDown={function (e) { return onKeyDownHandler(e, handleExpandAll); }}>
            {label}
          </ELSButton>
        </FalseStatement>
      </ConditionSection>
    </div>);
};
export default ExpandAllButton;
